import type { ScheduleTreeItem } from "@/adapters/api";
import { Skeleton } from "@/components/ui/skeleton.tsx";
import { STAGE_STATUS } from "@/features/stages/utils/status.ts";

const MILESTONE_SKELETONS = ["primeiro", "segundo", "terceiro"];

export interface MilestonesProps {
	stages?: ScheduleTreeItem[];
	isPending: boolean;
	isError: boolean;
}

export function Milestones({ stages, isPending, isError }: MilestonesProps) {
	if (isPending) {
		return (
			<ul className="milestones">
				{MILESTONE_SKELETONS.map((key) => (
					<li key={key}>
						<Skeleton className="milestone-skeleton" />
					</li>
				))}
			</ul>
		);
	}

	if (isError) {
		return (
			<p className="dashboard-panel-error" role="status">
				Não foi possível carregar as etapas da obra.
			</p>
		);
	}

	if (!stages || stages.length === 0) {
		return (
			<p className="dashboard-panel-empty" role="status">
				Nenhuma etapa cadastrada ainda.
			</p>
		);
	}

	return (
		<ol className="milestones">
			{stages.map((stage) => (
				<li
					key={stage.stage_id}
					className="milestone"
					data-status={stage.status}
				>
					<span className="milestone__marker" />
					<span className="milestone__name">{stage.name}</span>
					<span className="milestone__status">
						{STAGE_STATUS[stage.status].label}
					</span>
				</li>
			))}
		</ol>
	);
}
